export const wanderMaker = {
    view: {
      title: "Wander Maker Studio",
      subtitle: "Create and structure audio experiences for the Wanders app",
      newComposition: "New Composition",
      name: "Name",
      segments: "Segments",
      duration: "Duration",
      status: "Status",
      updated: "Last Updated",
      actions: "Actions",
      noCompositions: "No compositions yet. Create your first one!",
      untitled: "Untitled"
    },
    create: {
      title: "Create New Composition",
      name: "Composition Name",
      description: "Description (optional)",
      create: "Create"
    },
    delete: {
      title: "Delete Composition?",
      message: "This action cannot be undone. All audio files associated with this composition will also be deleted.",
      confirm: "Delete"
    },
    edit: {
      title: "Edit Wander",
      name: "Name"
    },
    wander: {
      create: "Create Wander",
      edit: "Edit Wander"
    },
    form: {
      name: "Name",
      description: "Description"
    },
    actions: {
      duplicate: "Duplicate"
    },
    status: {
      draft: "Draft",
      complete: "Complete",
      published: "Published"
    },
    segments: {
      presencing: "Presencing",
      poems: "Poems",
      prompt: "Prompt",
      backingTrack: "Backing Track"
    },
    studio: {
      title: "Wander Maker Studio",
      untitled: "Untitled Composition",
      unsavedChanges: "Unsaved changes",
      saveSuccess: "Composition saved successfully",
      saveError: "Failed to save composition",
      autoSaving: "Saving...",
      autoSaved: "Saved",
      autoSaveError: "Failed to auto-save",
      publishSuccess: "Composition published successfully!",
      publishError: "Failed to publish composition"
    },
    tabs: {
      structure: "Structure",
      presencing: "Presencing",
      poems: "Poems",
      prompt: "Prompt",
      backingTrack: "Backing Track",
      preview: "Preview"
    },
    packs: {
      label: "Wander pack",
      public: "Public (no pack)",
      createNew: "Create new pack…",
      createTitle: "Create wander pack",
      create: "Create pack",
      name: "Pack name",
      description: "Description",
      partnerName: "Partner name (optional)",
      websiteUrl: "Website (optional)",
      codeType: "Access",
      codeTypeOpen: "No code — available to everyone",
      codeTypeUnique: "Unique code per purchase",
      codeTypeShared: "One shared code for the pack",
      accessOpen: "Open — no code required",
      nameRequired: "Pack name is required",
      alreadyExists: "A pack with this name already exists",
      createError: "Failed to create pack",
      help: "Assign this wander to a pack. Open packs are available to everyone; code-gated packs require redemption. Leave public for the main catalogue.",
      orderInPack: "Will be wander #{{orderNo}} in {{packName}}",
      orderPublic: "Will be wander #{{orderNo}} in the public catalogue",
      sectionTitle: "Pack assignment",
      newPack: "New pack",
      assignedWriters: "Assigned wander writers",
      assignWritersPlaceholder: "Search wander writers…",
      assignedWritersHelp: "Writers can only add and edit wanders in packs they are assigned to.",
      copyShareLink: "Copy app link",
      shareLinkCopied: "Copied",
      downloadQr: "Download QR",
      downloadingQr: "Preparing QR…",
      downloadQrFailed: "Failed to generate QR code. Please try again.",
      noAssignedPacks: "No assigned packs",
      helpWithCreate: "Choose an existing pack, create a new one, or leave public for the main catalogue.",
      designSection: "Pack appearance",
      designSectionHelp: "Upload a logo for the pack card, and optionally design a pin for wander mode on the map.",
      packIcon: "Pack icon",
      packLogo: "Pack logo",
      mapPin: "Map pin",
      mapPinMissing: "Map pin image is missing from storage. Open Design map pin and save it again.",
      mapPinWillUploadOnSave: "The map pin will be uploaded when you save the pack.",
      mapPinUploadFailed: "Failed to upload the map pin image. Please try again.",
      saveFailed: "Failed to save pack. The map pin was not updated.",
      designIcon: "Design icon",
      designPin: "Design map pin",
      uploadImage: "Upload image",
      changeImage: "Change image",
      resetDesign: "Reset colours to default",
      cardBackgroundColor: "Card background",
      cardBackgroundColorHelper: "The pack card square background",
      textColor: "Text colour",
      textColorHelper: "Pack name and progress text",
      buttonBackgroundColor: "Button background",
      buttonBackgroundColorHelper: "Start Wander button fill",
      buttonTextColor: "Button text",
      buttonTextColorHelper: "Start Wander button label",
      responsesProjectLinked: "Responses project linked",
      responsesProjectMissing: "Responses project missing",
      openResponsesProject: "Open responses project",
      repairResponsesProject: "Repair responses project",
      repairingResponsesProject: "Repairing…",
      responsesProjectRepaired: "Responses project ready: {{projectId}}",
      responsesProjectRepairFailed: "Failed to repair responses project",
      responsesProjectRepairNeedSignIn: "Sign in to repair the responses project",
      responsesProjectBackfilled: "Linked responses projects for {{count}} pack(s)",
      updated: "Pack updated",
      wandersSection: "Wanders",
      noWandersInPack: "No wanders in this pack yet.",
      unassignedWanders: "Unassigned wanders",
      moveWanderUp: "Move wander up",
      moveWanderDown: "Move wander down",
      engagement: {
        runs: "Runs",
        listens: "Listens",
        responses: "Responses",
        runsTooltip: "Times a wander pin was placed for a listener (new starts and reruns). {{users}} unique listener(s).",
        listensTooltip: "Times a listener reached the pin and heard the prompt audio through. {{users}} unique listener(s).",
        responsesTooltip: "Reflections saved after the wander. {{users}} unique listener(s).",
        lastActivity: "Last: {{when}}",
      },
      responsesProjectHelp:
        "Each pack has a shared responses project. It stays hidden from public catalogues until the first listener reflection is saved.",
    },
    structure: {
      title: "Composition Details",
      name: "Name",
      linkWander: "Link to Wander",
      selectWander: "Select Wander",
      noWander: "No wander linked",
      linkWanderHelp: "Link this composition to an existing wander. Published audio will be added to the linked wander.",
      status: "Status",
      publish: "Publish",
      publishing: "Publishing...",
      unpublish: "Unpublish",
      publishRequirements: "To publish, you need at least presencing/poems and prompt audio, and a linked wander.",
      segments: "Wander Segments",
      segmentsHelp: "Enable the segments you want to include in your wander. Each segment will appear as a tab above for editing.",
      presencing: "Presencing",
      presencingDesc: "Opening audio to ground and prepare the listener",
      poems: "Poems",
      poemsDesc: "1-3 poems with optional bridge transitions",
      prompt: "Prompt",
      promptDesc: "Closing prompt to inspire creativity and invite recording",
      backingTrack: "Backing Track",
      backingTrackDesc: "Background music bed with fade in/out controls"
    },
    presencing: {
      title: "Presencing Audio",
      description: "This audio plays when the user starts walking to prepare and ground them for the experience."
    },
    poems: {
      title: "Poems",
      description: "The main content of your wander - add 1-3 poems with optional bridge transitions.",
      instructions: "Add up to 3 poems for your wander. Each poem can have an optional bridge audio that plays as a transition to the next segment. Drag poems to reorder them.",
      poem: "Poem",
      bridge: "Bridge",
      addPoem: "Add Poem",
      removePoem: "Remove poem",
      addBridge: "Add bridge audio",
      removeBridge: "Remove bridge",
      summary: "Sequence Summary"
    },
    prompt: {
      title: "Prompt Audio",
      description: "The closing audio that invites listeners to record their own response in the place they have ended up."
    },
    backingTrack: {
      title: "Backing Track",
      description: "The background music bed that plays underneath all other audio with customisable fade controls.",
      fadeControls: "Fade Controls",
      fadeIn: "Fade In Duration",
      fadeOut: "Fade Out Duration",
      volume: "Volume",
      preview: "Preview with Fade",
      previewFade: "Preview with fade",
      stop: "Stop"
    },
    recorder: {
      startRecording: "Start Recording",
      stopRecording: "Stop Recording",
      converting: "Converting to MP3...",
      or: "or",
      uploadFile: "Upload File",
      reRecord: "Re-record",
      recordNew: "Record new audio",
      addAudio: "Add audio to end",
      replaceAudio: "Replace audio"
    },
    waveform: {
      noAudio: "No audio loaded",
      play: "Play",
      pause: "Pause",
      stop: "Stop",
      playTrimmed: "Play trimmed region",
      zoomIn: "Zoom in",
      zoomOut: "Zoom out",
      cutSections: "Cut Sections from Middle",
      cutInstructions: "Click the scissor icon above to enable cut mode, then click and drag on the waveform to mark sections for removal.",
      cutInstructionsActive: "Click and drag on the waveform to mark sections for removal. Click a red region to remove it.",
      enableCutMode: "Enable cut mode",
      disableCutMode: "Disable cut mode",
      applyCuts: "Apply Cuts",
      clearCuts: "Clear All",
      cutRegionsCount: "{{count}} section(s) marked for removal",
      processing: "Processing...",
      trimControls: "Trim Controls",
      trimStart: "Start",
      trimEnd: "End",
      trimmedDuration: "Trimmed duration",
      resetTrim: "Reset trim",
      applyTrim: "Apply Trim",
      showTrimControls: "Show trim controls",
      hideTrimControls: "Hide trim controls"
    },
    timeline: {
      title: "Composition Timeline",
      totalDuration: "Total",
      presencing: "Presencing",
      poem: "Poem",
      bridge: "Bridge",
      prompt: "Prompt",
      backingTrack: "Backing Track",
      poems: "Poems",
      bridges: "Bridges",
      noAudio: "No audio",
      empty: "No segments configured",
      legend: "Legend"
    },
    preview: {
      tabTitle: "Preview audio",
      tabHelp: "Choose a 3–10 second clip from this wander. Saved clips are stitched into the pack preview for the app.",
      title: "Wander preview",
      savedBadge: "saved",
      noAudio: "Add audio to a poem, presencing, or prompt segment before setting a preview.",
      tooShort: "Preview requires at least 3 seconds of audio.",
      demoDisabled: "Saving preview audio is disabled in demo mode.",
      sourceLabel: "Preview source",
      selection: "Selection {{start}}s – {{end}}s ({{duration}}s). Drag the handles to keep the clip between 3 and 10 seconds.",
      fadeIn: "Fade in ({{value}}s)",
      fadeOut: "Fade out ({{value}}s)",
      playSelection: "Play selection",
      playingSelection: "Playing…",
      save: "Save wander preview",
      saving: "Saving…",
      download: "Download preview",
      clear: "Clear preview",
      clearing: "Clearing…",
      savedPreviewLabel: "Saved wander preview",
      saved: "Wander preview saved.",
      cleared: "Wander preview cleared.",
      saveFailed: "Failed to save wander preview",
      clearFailed: "Failed to clear wander preview",
      downloadFailed: "Failed to download wander preview",
      noPackHint: "Assign this wander to a pack on the Structure tab to stitch wander previews into a pack preview file.",
      sources: {
        presencing: "Presencing",
        poem: "Poem {{index}}",
        poemTitled: "Poem {{index}} — {{title}}",
        bridge: "Bridge after poem {{index}}",
        prompt: "Prompt",
        backingTrack: "Backing track"
      },
      pack: {
        sectionTitle: "Pack preview",
        help: "Stitch saved wander previews in pack order into one clip for {{packName}}.",
        savedBadge: "saved",
        outdatedBadge: "changes pending",
        unsavedFlag: "Wander previews are ready — save a pack preview for the app.",
        outdatedFlag: "Wander previews have changed — save the pack preview again for the app.",
        play: "Play preview",
        playing: "Preparing playback…",
        playFailed: "Failed to prepare pack preview playback",
        save: "Save pack preview",
        saving: "Saving preview…",
        saved: "Pack preview saved for the app.",
        saveFailed: "Failed to save pack preview",
        download: "Download pack preview",
        downloading: "Downloading preview…",
        downloaded: "Pack preview downloaded.",
        downloadFailed: "Failed to build pack preview",
        empty: "No saved wander previews in this pack yet.",
        crossfade: "Crossfade between clips ({{value}}s)",
        crossfadeNeedsClips: "Crossfade only applies when two or more wander previews are saved.",
        crossfadePlayHint: "Press Play preview to hear the current crossfade.",
        upload: "Upload custom preview",
        uploading: "Uploading preview…",
        uploaded: "Custom pack preview uploaded.",
        uploadFailed: "Failed to upload pack preview",
        uploadHint: "Upload an MP3 to override the auto-stitched preview for the app.",
        clear: "Clear pack preview",
        clearing: "Clearing…",
        cleared: "Pack preview cleared.",
        clearFailed: "Failed to clear pack preview",
        matesTitle: "Wanders in this pack",
        matesHelp: "Select a wander to set its preview clip. Saved clips are stitched into the pack preview above.",
        matesEmpty: "No other wanders in this pack yet.",
        thisWander: "this wander",
        mateSaved: "Preview saved",
        mateMissing: "Missing preview"
      }
    }
}